import ElementNotificatonPresenter from "../../element-notification/presenter/element-notification.js";

import CartPromocodeFormView from "../view/form.js";

import CartPromocodeModel from "../model/cart-promocode.js";

import {
  sendXhr
} from "../../../utils/send-xhr/send-xhr.js";

import {
  defaultCartPromocodeModelData,
  RequestAction,
  CONNECTOR_URL,
  ActionType,
  PROMOCODE_INPUT_NAME,
  NOTIFICATION_DISPLAY_TIME
} from "../const.js";

import {
  currentServerType,
  ServerType
} from "../../../const.js";

import {
  Style as NotificationStyle
} from "../../element-notification/const.js";

import {
  InfoMessage
} from "../lexicon.js";

import {
  VALID_PROMOCODES
} from "../mock.js";

export default class CartPromocode {
  constructor(formElement) {
    this._formElement = formElement;

    this._elementNotificaton = null;

    this._formView = null;
    this._model = null;

    this._requestQueue = null;
    this._notificationDisplayTimeout = null;

    this._handleFormSubmit = this._handleFormSubmit.bind(this);
    this._handleFormInput = this._handleFormInput.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._formView = new CartPromocodeFormView(this._formElement);
    this._formView.setSubmitHandler(this._handleFormSubmit);
    this._formView.setInputHandler(this._handleFormInput);

    this._elementNotificaton = new ElementNotificatonPresenter(this._formView.getInputParentElement());
    this._elementNotificaton.init();

    this._model = new CartPromocodeModel(Object.assign(
        {},
        defaultCartPromocodeModelData
    ));
    this._model.addObserver(this._handleChangeData);
  }

  _showNotification(style) {
    this._elementNotificaton.render(this._model.getData().message, style);

    this._notificationDisplayTimeout = setTimeout(() => {
      this._elementNotificaton.destroy();
    }, NOTIFICATION_DISPLAY_TIME);
  }

  _hideNotification() {
    clearTimeout(this._notificationDisplayTimeout);
    this._elementNotificaton.destroy();
  }

  _processApplyPromocode() {
    this._formView.setValid();
    this._showNotification(NotificationStyle.SUCCESS);
  }

  _processSetInvalid() {
    this._formView.setInvalid();
    this._showNotification(NotificationStyle.ERROR);
  }

  _processRemovePromocode() {
    this._formView.reset();
    this._showNotification(NotificationStyle.INFO);
  }

  _processReset() {
    this._formView.reset();

    this._hideNotification();
  }

  _handleFormInput() {
    this._elementNotificaton.destroy();

    if (this._model.getData().isValid === false) {
      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            promocode: null,
            isValid: null,
            message: null
          }
      ), ActionType.RESET);
    }
  }

  _handleFormSubmit(evt) {
    evt.preventDefault();

    const form = evt.target;
    const formData = new FormData(form);
    const promocode = formData.get(PROMOCODE_INPUT_NAME);

    if (currentServerType !== ServerType.LAYOUT) {
      if (this._model.getData().isValid) {
        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              promocode: null,
              isValid: null,
              message: InfoMessage.REMOVED
            }
        ), ActionType.REMOVE_PROMOCODE);
        return;
      }

      if (promocode === ``) {
        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              promocode: null,
              isValid: false,
              message: InfoMessage.EMPTY
            }
        ), ActionType.SET_INVALID);
        return;
      }

      const action = (VALID_PROMOCODES.indexOf(promocode) !== -1) ?
        ActionType.APPLY_PROMOCODE :
        ActionType.SET_INVALID;
      const message = (VALID_PROMOCODES.indexOf(promocode) !== -1) ?
        InfoMessage.VALID :
        InfoMessage.INVALID;

      this._model.changeData(Object.assign(
          {},
          this._model.getData(),
          {
            promocode,
            isValid: (VALID_PROMOCODES.indexOf(promocode) !== -1) ? true : false,
            message
          }
      ), action);
    } else {
      if (this._model.getData().isValid) {
        const requestArgs = {
          body: [
            `action=${RequestAction.APPLY_PROMOCODE}`,
            `promocode=${promocode}`
          ],
          connectorUrl: CONNECTOR_URL,
          loadCallback: (response) => {
            const data = JSON.parse(response);

            if (data.error) {
              console.error(`Ошибка при удалении промокода. Текст ошибки: ${data.error}`);
            }

            this._model.changeData(Object.assign(
                {},
                this._model.getData(),
                {
                  promocode: null,
                  isValid: null,
                  message: InfoMessage.REMOVED
                }
            ), ActionType.REMOVE_PROMOCODE);
          },
          requestQueue: this._requestQueue
        };
        sendXhr(requestArgs);
        return;
      }

      if (promocode === ``) {
        this._model.changeData(Object.assign(
            {},
            this._model.getData(),
            {
              promocode: null,
              isValid: false,
              message: InfoMessage.EMPTY
            }
        ), ActionType.SET_INVALID);
        return;
      }

      const requestArgs = {
        body: [
          `action=${RequestAction.APPLY_PROMOCODE}`,
          `promocode=${promocode}`
        ],
        connectorUrl: CONNECTOR_URL,
        loadCallback: (response) => {
          const data = JSON.parse(response);
          const action = (data.isValid) ?
            ActionType.APPLY_PROMOCODE :
            ActionType.SET_INVALID;
          const message = (data.isValid) ?
            InfoMessage.VALID :
            InfoMessage.INVALID;

          this._model.changeData(Object.assign(
              {},
              this._model.getData(),
              {
                isValid: data.isValid,
                promocode: data.promocode,
                message
              }
          ), action);
        },
        requestQueue: this._requestQueue
      };
      sendXhr(requestArgs);
    }
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.APPLY_PROMOCODE:
        this._processApplyPromocode();
        break;
      case ActionType.SET_INVALID:
        this._processSetInvalid();
        break;
      case ActionType.REMOVE_PROMOCODE:
        this._processRemovePromocode();
        break;
      case ActionType.RESET:
        this._processReset();
        break;
    }
  }
}
